namespace Matrix.DataAudit {
    export interface AccountHistoryListRequest extends Serenity.ListRequest {
        ViewUnion?: boolean;
        StartDate?: string;
        EndDate?: string;
    }
}
